
function Stages2() {
	return ( 
		<div>
			<div>
				<p>
					Spechte machen sich auf der Suche nach Insekten an der Rinde des Baumes zu schaffen.
				</p>
			</div>
		</div>
	 );
}

export default Stages2;